<div class="flex flex-col">
  <ng-container *ngIf="notifications.length; else empty">
    <button
      *ngFor="let n of notifications"
      type="button"
      class="group flex items-start gap-3 w-full text-left px-4 py-3.5 border-b border-surface last:border-b-0 hover:bg-surface-50 transition-colors"
      [ngClass]="{ 'bg-primary-50/40': !n.read }"
      (click)="onItemClick(n)"
    >
      <!-- Leading icon -->
      <span
        class="flex items-center justify-center w-9 h-9 rounded-full flex-shrink-0"
        [ngClass]="n.read ? 'bg-surface-100 text-surface-500' : 'bg-primary-100 text-primary'"
      >
        <i class="pi pi-bell text-sm"></i>
      </span>

      <span class="flex-1 min-w-0 pt-0.5">
        <span class="flex items-center gap-2">
          <span
            class="block truncate flex-1"
            [ngClass]="n.read ? 'font-medium text-primary-900' : 'font-semibold text-primary-900'"
            >{{ n.title }}</span
          >
          <span
            *ngIf="!n.read"
            class="h-2 w-2 rounded-full bg-primary flex-shrink-0"
          ></span>
        </span>
        <span class="text-sm text-surface-600 line-clamp-2 mt-0.5" [innerHTML]="n.message"></span>
        <span class="flex items-center gap-1 text-xs text-surface-400 mt-1.5">
          <i class="pi pi-clock" style="font-size: 0.7rem"></i>
          {{ n.createdAt | date: 'MMM d, y, h:mm a' }}
        </span>
      </span>
    </button>
  </ng-container>

  <ng-template #empty>
    <div class="px-4 py-12 text-center text-surface-500">
      <span class="flex items-center justify-center w-14 h-14 rounded-full bg-surface-100 mx-auto mb-3">
        <i class="pi pi-bell text-2xl text-surface-400"></i>
      </span>
      <p class="font-medium text-primary-900">{{ emptyMessage }}</p>
      <p class="text-sm text-surface-400 mt-1">We'll let you know when something comes up.</p>
    </div>
  </ng-template>
</div>
